import type * as ReactRouter from "react-router";
import { AboutPage } from "~/app/components/landing/about-page";
import { t } from "~/app/i18n";

export const meta: ReactRouter.MetaFunction = () => [
  { title: t("About.metaTitle") },
  { name: "description", content: t("About.metaDescription") },
];

export default function AboutPL() {
  return <AboutPage locale="pl" />;
}
